import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { createCallRouting, getPredefs } from 'flow/actions/call-routing-actions';
import { fetchProfiles } from 'flow/actions/profile-actions';
import Button from 'flow/components//ui-components/Button';
import ReferralNumberCombobox from 'flow/components/Setting/components/ReferralNumberCombobox';
import SettingRow from 'flow/components/Setting/SettingRow';
import SettingSection from 'flow/components/Setting/SettingSection';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Divider from 'flow/components/ui-components/Divider';
import DropdownMenuComponent from 'flow/components/ui-components/DropdownMenuComponent';
import InputField from 'flow/components/ui-components/InputField';
import RadioButton from 'flow/components/ui-components/RadioButton';
import useAppContext from 'flow/hooks/useAppContext';
import useProfiles from 'flow/hooks/useProfiles';
import { numberIsValidMatcher } from 'flow/utils/call-utils';
import { fromJS, List } from 'immutable';
import React, { useEffect, useId, useState } from 'react';
import { useAppSelector, useAppDispatch } from 'flow/hooks/useRedux';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var formatWithPredefList = function formatWithPredefList(type) {
  // Takes the input and trims everything before and including '_'
  return 'predefList_' + type.replace(/^.*?_/, '');
};
var isValueAlreadyExists = function isValueAlreadyExists(blocklists, newBlocklistMatcher) {
  return blocklists.some(function (blocklist) {
    var matcher = blocklist === null || blocklist === void 0 ? void 0 : blocklist.get('matcher');
    return matcher.replace(/\*$/, '') === newBlocklistMatcher;
  });
};
var CreateProfileModal = function CreateProfileModal(_ref) {
  var extensionKey = _ref.extensionKey,
    type = _ref.type;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var _useProfiles = useProfiles(extensionKey),
    profiles = _useProfiles.profiles;
  var predefList = useAppSelector(function (state) {
    return state.callRoutings.get(formatWithPredefList(type));
  });
  var callRoutings = useAppSelector(function (state) {
    return state.callRoutings.getIn([type]);
  });
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    redirect = _useState2[0],
    setRedirect = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    predef = _useState4[0],
    setPredef = _useState4[1];
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    number = _useState6[0],
    setNumber = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    exceptionInput = _useState8[0],
    setExceptionInput = _useState8[1];
  var _useState9 = useState(null),
    _useState0 = _slicedToArray(_useState9, 2),
    exceptions = _useState0[0],
    setExceptions = _useState0[1];
  var _useState1 = useState(null),
    _useState10 = _slicedToArray(_useState1, 2),
    profileDuring = _useState10[0],
    setProfileDuring = _useState10[1];
  var _useState11 = useState(),
    _useState12 = _slicedToArray(_useState11, 2),
    referralNumber = _useState12[0],
    setReferralNumber = _useState12[1];
  var _useState13 = useState(''),
    _useState14 = _slicedToArray(_useState13, 2),
    numberInputError = _useState14[0],
    setNumberInputError = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    error = _useState16[0],
    setError = _useState16[1];

  // Ties each hint and error paragraph to its field with aria-describedby.
  var idPrefix = useId();
  var numberErrorId = "".concat(idPrefix, "-number-error");
  var exceptionAddHintId = "".concat(idPrefix, "-exception-add-hint");
  var exceptionHelpId = "".concat(idPrefix, "-exception-help");
  var exceptionErrorId = "".concat(idPrefix, "-exception-error");
  var exceptionDescribedBy = [type !== 'blocked_out' ? exceptionAddHintId : null, exceptionHelpId, error ? exceptionErrorId : null].filter(Boolean).join(' ');
  var _useState17 = useState(false),
    _useState18 = _slicedToArray(_useState17, 2),
    shouldShowForwardToNumberRedirect = _useState18[0],
    setShouldShowForwardToNumberRedirect = _useState18[1];
  var _useState19 = useState(false),
    _useState20 = _slicedToArray(_useState19, 2),
    shouldShowForwardToNumberAction = _useState20[0],
    setShouldShowForwardToNumberAction = _useState20[1];
  useEffect(function () {
    dispatch(getPredefs());
    dispatch(fetchProfiles(extensionKey));
  }, []);
  var profileOptions = profiles.map(function (profile) {
    return {
      key: profile.get('key'),
      label: profile.get('description')
    };
  }).toArray();
  var options = [{
    key: null,
    label: i18next.t('settings.callrouting.profile.allprofiles')
  }].concat(profileOptions);
  var blockListDTO = fromJS({
    editByUser: true,
    isIncoming: type === 'priority' || type === 'blocked_in',
    redirect: redirect
  });
  var createNewCallRouting = function createNewCallRouting() {
    if (exceptions) {
      var matcherObjects = exceptions.matcher.map(function (value) {
        return {
          matcher: value
        };
      });
      blockListDTO = blockListDTO.setIn(['blocklistExceptions'], List(matcherObjects));
    }
    if (profileDuring) {
      blockListDTO = blockListDTO.setIn(['profileDTO'], profiles.find(function (profile) {
        return profile.get('key') === profileDuring;
      }));
    }
    if (numberIsValidMatcher(number)) {
      blockListDTO = blockListDTO.setIn(['matcher'], number);
    }
    if (redirect || referralNumber) {
      blockListDTO = blockListDTO.setIn(['redirect'], referralNumber === null || referralNumber === void 0 ? void 0 : referralNumber.dto.get('number'));
    } else {
      blockListDTO = blockListDTO.setIn(['redirect'], redirect);
    }
    if (predef) {
      blockListDTO = blockListDTO.setIn(['blocklistPredefDTO'], predef);
    }
    if (type === 'priority') {
      blockListDTO = blockListDTO.setIn(['redirect'], 'passthrough');
    }
    dispatch(createCallRouting(blockListDTO));
  };
  var handleNumberChange = function handleNumberChange(e) {
    var newNumber = e.target.value;
    setNumber(newNumber);
    if (isValueAlreadyExists(callRoutings, newNumber)) {
      setNumberInputError('Number already exists');
    } else {
      setNumberInputError('');
    }
  };
  var handleAddException = function handleAddException(exception) {
    setExceptions(function (prevDTO) {
      if (prevDTO !== null && prevDTO !== void 0 && prevDTO.matcher.includes(exception)) {
        setError("Exception for ".concat(exception, " already exists"));
        return prevDTO;
      } else {
        setError('');
        return _objectSpread(_objectSpread({}, prevDTO), {}, {
          matcher: [].concat(_toConsumableArray((prevDTO === null || prevDTO === void 0 ? void 0 : prevDTO.matcher) || []), [exception])
        });
      }
    });
  };
  var handleRemoveException = function handleRemoveException(indexToRemove) {
    setExceptions(function (prevDTO) {
      return _objectSpread(_objectSpread({}, prevDTO), {}, {
        matcher: prevDTO.matcher.filter(function (_, index) {
          return index !== indexToRemove;
        })
      });
    });
  };
  var findLabelByKey = function findLabelByKey(key) {
    var option = options.find(function (option) {
      return option.key === key;
    });
    return option ? option.label : '';
  };
  var isDisabled = function isDisabled() {
    if (predef === '') {
      return !(exceptionInput.startsWith(number) && exceptionInput.length > number.length);
    }
    return false;
  };
  return /*#__PURE__*/_jsx(BaseModal, {
    open: true,
    header: i18next.t('settings.callrouting.add.redirect'),
    disableSubmit: !(numberIsValidMatcher(number) || predef),
    onSubmit: createNewCallRouting,
    confirmButtonText: i18next.t('settings.callrouting.add.redirect'),
    className: "w-[600px]",
    children: /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col px-2 pb-9",
      children: [/*#__PURE__*/_jsx(SettingSection, {
        children: i18next.t('settings.callrouting.add.option.number.redirect')
      }), type !== 'priority' ? /*#__PURE__*/_jsx(RadioButton, {
        name: 'number',
        onChange: function onChange() {
          setShouldShowForwardToNumberRedirect(true);
          setPredef('');
        },
        checked: predef === '' && shouldShowForwardToNumberRedirect,
        children: i18next.t('settings.number')
      }) : null, predefList && predefList.sort().map(function (predefOption) {
        return /*#__PURE__*/_jsx(RadioButton, {
          name: predefOption === null || predefOption === void 0 ? void 0 : predefOption.get('name'),
          onChange: function onChange() {
            setPredef(predefOption);
            setRedirect(null);
          },
          checked: predef === predefOption,
          children: predefOption === null || predefOption === void 0 ? void 0 : predefOption.get('description')
        }, predefOption === null || predefOption === void 0 ? void 0 : predefOption.get('name'));
      }), shouldShowForwardToNumberRedirect && !predef || type === 'priority' ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(SettingSection, {
          children: [i18next.t('settings.number'), /*#__PURE__*/_jsx("span", {
            children: "\xA0*"
          })]
        }), /*#__PURE__*/_jsx(InputField, {
          placeholder: 'Enter a number',
          value: number,
          onChange: handleNumberChange,
          "aria-invalid": numberInputError ? true : undefined,
          "aria-describedby": numberInputError ? numberErrorId : undefined
        }), numberInputError && /*#__PURE__*/_jsx("p", {
          id: numberErrorId,
          role: "alert",
          className: "text-red pr-2 text-sm",
          children: numberInputError
        })]
      }) : null, /*#__PURE__*/_jsx(Divider, {}), type === 'blocked_in' ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SettingSection, {
          children: i18next.t('settings.callrouting.action')
        }), /*#__PURE__*/_jsx(RadioButton, {
          name: 'settings.callrouting.action.playblock',
          onChange: function onChange() {
            setShouldShowForwardToNumberAction(false);
            setRedirect(null);
          },
          checked: !redirect && !shouldShowForwardToNumberAction,
          children: i18next.t('settings.callrouting.action.playblock')
        }), /*#__PURE__*/_jsx(RadioButton, {
          name: 'settings.callrouting.action.tovoicemail',
          onChange: function onChange() {
            setShouldShowForwardToNumberAction(false);
            setRedirect('voicemail');
          },
          checked: redirect === 'voicemail',
          children: i18next.t('settings.callrouting.action.tovoicemail')
        }), /*#__PURE__*/_jsx(RadioButton, {
          name: 'settings.callrouting.action.tonumber',
          onChange: function onChange() {
            setShouldShowForwardToNumberAction(true);
            setRedirect(null);
          },
          checked: shouldShowForwardToNumberAction,
          children: i18next.t('settings.callrouting.action.tonumber')
        }), /*#__PURE__*/_jsx(Divider, {})]
      }) : null, shouldShowForwardToNumberAction && !redirect ? /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(SettingSection, {
          className: "text-sm/4",
          children: [i18next.t('settings.callrouting.action.picknumber'), /*#__PURE__*/_jsx("span", {
            children: "\xA0*"
          })]
        }), /*#__PURE__*/_jsx(ReferralNumberCombobox, {
          ariaLabel: i18next.t('settings.callrouting.action.picknumber'),
          referralNumber: referralNumber,
          onChange: setReferralNumber
        })]
      }) : null, /*#__PURE__*/_jsx(SettingSection, {
        children: i18next.t('settings.callrouting.exceptions')
      }), /*#__PURE__*/_jsx(SettingSection, {
        children: i18next.t('settings.number')
      }), /*#__PURE__*/_jsx(InputField, {
        placeholder: 'Enter a number' // Order translation
        ,
        value: exceptionInput,
        disabled: !number && redirect,
        defaultValue: number,
        onChange: function onChange(e) {
          setExceptionInput(e.target.value);
          if (error) setError('');
        },
        "aria-invalid": error ? true : undefined,
        "aria-describedby": exceptionDescribedBy
      }), type !== 'blocked_out' ? /*#__PURE__*/_jsx("p", {
        id: exceptionAddHintId,
        className: "p-2 text-xs text-gray-500",
        children: i18next.t('settings.callrouting.exceptions.add.error')
      }) : null, /*#__PURE__*/_jsx("p", {
        id: exceptionHelpId,
        className: "p-2 text-xs text-gray-500",
        children: i18next.t('settings.callrouting.exceptions.helptext')
      }), /*#__PURE__*/_jsx(Button, {
        color: "primary",
        className: "my-4 min-w-max px-5",
        disabled: isDisabled(),
        onClick: function onClick() {
          if (exceptionInput.trim() !== '') {
            handleAddException(exceptionInput.trim());
            setExceptionInput('');
          }
        },
        children: i18next.t('settings.callrouting.exceptions.add')
      }), error && /*#__PURE__*/_jsx("p", {
        id: exceptionErrorId,
        role: "alert",
        className: "text-red pr-2 text-sm",
        children: error
      }), exceptions && exceptions.matcher.map(function (exception, index) {
        return /*#__PURE__*/_jsx(SettingRow, {
          cta: /*#__PURE__*/_jsx(Button, {
            iconKey: "delete",
            onClick: function onClick() {
              return handleRemoveException(index);
            }
          }),
          children: exception
        }, exception);
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx(SettingSection, {
        children: i18next.t('settings.callrouting.during')
      }), /*#__PURE__*/_jsx(DropdownMenuComponent, {
        options: options,
        title: findLabelByKey(profileDuring),
        onItemSelected: function onItemSelected(profile) {
          return setProfileDuring(profile);
        }
      }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsxs("span", {
        className: "text-sm/4",
        children: ["*\xA0", i18next.t('fields.required_field')]
      })]
    })
  });
};
export default CreateProfileModal;